import { render, staticRenderFns } from "./remindResponse.vue?vue&type=template&id=412b04eb&scoped=true&"
import script from "./remindResponse.vue?vue&type=script&lang=js&"
export * from "./remindResponse.vue?vue&type=script&lang=js&"
import style0 from "./remindResponse.vue?vue&type=style&index=0&id=412b04eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412b04eb",
  null
  
)

export default component.exports